import React from 'react';
import type { ComponentProps } from 'react';
import styled from '@emotion/styled';

import ContainerWithBackground, { containerWithBackgroundStyles } from './ContainerWithBackground';

const UnstyledStyledContainerWithBackground = styled(ContainerWithBackground)``;

export const styledContainerWithBackgroundStyles: ComponentProps<typeof ContainerWithBackground> = {
  ...containerWithBackgroundStyles,
  py: ['sp_16', null, null, 'sp_20'],
  px: ['sp_12', 'sp_16', null, 'sp_24'],
  position: 'relative',
};

const StyledContainerWithBackground = (
  props: ComponentProps<typeof UnstyledStyledContainerWithBackground>
) => <UnstyledStyledContainerWithBackground {...styledContainerWithBackgroundStyles} {...props} />;

export default StyledContainerWithBackground;
